import React, { Component } from 'react'
import { Table, Tag, message, Popconfirm, Select } from 'antd';
import { FirebaseRef } from '../../lib/firebase'
import serviceMail from '../../services/sendmail'
import { EditableCell, EditableFormRow } from './../../components/CustomerTable'

const { Option } = Select;

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      visibleSignUp: false,
      action: false,
      status: 'pending'
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    let ref = FirebaseRef.child(`/reQuest`)
    ref.on('value', snapshot => {
      const data = snapshot.val()
      if (data && typeof (data) === 'object') {
        let newData = []
        Object.keys(data).forEach(key => {
          if (data[key]) {
            newData.push({
              ...data[key],
              id: key,
            })
          }
        })
        const newArray = newData.reverse()

        this.setState({
          data: newArray

        })
      }
      this.setState({
        loading: false
      })
    })
  }

  handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message
    }
    serviceMail.sendMail(data).then(() => {
    })
  }

  confirm(id) {
    const ref = FirebaseRef.child(`reQuest/${id}`)

    ref.remove().then(() => {
      message.success("request user was removed!")

    }).catch(err => {
      message.error(err)
    })
  }

  handleSave = row => {

    const ref = FirebaseRef.child(`/reQuest/${row.id}`)
    ref.set({
      ...row
    })


  };

  render() {

    const columns = [
      {
        title: 'First name',
        dataIndex: 'firstName',
        key: 'firstName',
        editable: true,
        render: text => <>
          {text}
        </>,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'First name for Url',
        dataIndex: 'firstNameUrl',
        key: 'firstNameUrl',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span>
            <Popconfirm placement="top" title={"Bạn có chắc sẽ xóa người dùng này ?"} onConfirm={() => { this.confirm(record.id) }} okText="Có" cancelText="không">
              <Tag color={"red"} key={"delete"}>
                Xoá
                </Tag>
            </Popconfirm>
            {status === "pending" ? (
              <Tag
                onClick={() => {
                  record.status = "active"
                  this.handleSave(record)
                }}
                color={"rgb(254, 140, 0)"}
                key={"approve"}>
                Approve
              </Tag>
            ) : null}


          </span >
        ),
      },
    ];

    const { data, loading, status } = this.state

    const newData = data.filter(item => item.status === status)

    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const newColumns = columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: (record) => { this.handleSave(record) },
        }),
      };
    });

    return (
      <div >
        <div style={{ textAlign: "right", width: "100%", marginBottom: "15px" }}>
          <Select

            placeholder="Status"
            value={status}
            style={{
              width: "250px",
              marginRight: "20px",
              textAlign: "left",
            }}

            onChange={(value) => {
              this.setState({
                status: value
              })
            }}
          >

            <Option key={1} value={"pending"}>Pending</Option>
            <Option key={2} value={"active"}>Active</Option>
          </Select>
        </div>
        <Table rowClassName={() => 'editable-row'} components={components} loading={loading} columns={newColumns} dataSource={newData} />

      </div>
    )
  }

}
export default Home;
